<template>
  <Card>
    <InsideContent
      class="bids-add-bulk-column-chooser"
      :title="$t('ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_TITLE')"
      :description="$t('ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_DESCRIPTION')"
    >
      <BidsAddBulkColumnSlider v-model="selectedColumn" :data="columnsData" />

      <div class="bids-add-bulk-column-chooser__actions">
        <ElButton type="text" icon="el-icon-arrow-right" @click="cancel">
          {{ $t('ADVERTISEMENT.BULK_IMPORT.PREV_STEP') }}
        </ElButton>
        <ElButton :disabled="columnNotSelected" type="primary" @click="choose">
          {{ $t('ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_NEXT_STEP') }}
        </ElButton>
      </div>
    </InsideContent>
  </Card>
</template>

<script>
import InsideContent from '@@/common/layout/InsideContent';
import Card from '@@/common/Card';

import BidsAddBulkColumnSlider from './BidsAddBulkColumnSlider';

export default {
  name: 'BidsAddBulkColumnChooser',
  components: {
    InsideContent,
    BidsAddBulkColumnSlider,
    Card,
  },
  props: {
    csvData: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      selectedColumn: -1,
    };
  },
  computed: {
    columnNotSelected() {
      return this.selectedColumn === -1;
    },
    columnsData() {
      const limitedDataWithTitle = [];

      for (let i = 0; i < this.csvData.length; i++) {
        limitedDataWithTitle.push({
          title: i + 1,
          items: this.csvData[i].slice(0, 4),
        });
      }

      return limitedDataWithTitle;
    },
  },
  methods: {
    choose() {
      if (this.columnNotSelected) return;
      this.$emit('choose', this.selectedColumn);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-column-chooser {
  &__actions {
    display: flex;
    justify-content: flex-end;

    margin-top: $global-margin * 2;
  }
}
</style>
